"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftViewContainer = void 0;
const react_1 = __importStar(require("react"));
const context_1 = require("../../../shared/context");
const sdk_1 = require("../../sdk");
const react_router_dom_1 = require("react-router-dom");
const renderEditButton = (draftId) => (react_1.default.createElement("div", { className: "draft__title-actions" },
    react_1.default.createElement("a", { href: `/drafts/${draftId}/edit`, className: "button action s" }, "Edit")));
const DraftView = ({ draft }) => {
    var _a;
    const ctx = react_1.useContext(context_1.AppContext);
    return (react_1.default.createElement("div", { className: "draft" },
        react_1.default.createElement("a", { href: "/drafts" }, "\u2191 Back to the drafts"),
        react_1.default.createElement("div", { className: "draft__title" },
            draft.title,
            ((_a = ctx.user) === null || _a === void 0 ? void 0 : _a.username) === draft.author && renderEditButton(draft.id)),
        react_1.default.createElement("div", { className: "page" },
            react_1.default.createElement("div", { className: "draft__content page__content", dangerouslySetInnerHTML: { __html: draft.renderedContent } }))));
};
exports.DraftViewContainer = () => {
    const [draft, setDraft] = react_1.useState();
    const match = react_router_dom_1.useRouteMatch();
    const draftId = (match === null || match === void 0 ? void 0 : match.params).id;
    if (draft) {
        return react_1.default.createElement(DraftView, { draft: draft });
    }
    else {
        sdk_1.sdk.getDraft(draftId).then(setDraft).catch(sdk_1.sdk.reportClientError);
        return react_1.default.createElement("div", null); // TODO loader?
    }
};
//# sourceMappingURL=DraftView.js.map